import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import SevenstarPage from './components/SevenstarPage';

app.initializers.add('taro-sevenstar', () => {
  // 独立页面路由：/sevenstar（登录后可用）
  app.routes.sevenstar = {
    path: '/sevenstar',
    component: SevenstarPage,
  };

  // 顶部导航栏加入"七星查询"按钮（仅登录用户可见）→ 跳转独立页
  extend(HeaderPrimary.prototype, 'items', function (items) {
    if (!app.session.user) return;

    items.add(
      'taro-sevenstar',
      <a
        className="Button Button--flat sevenstar-nav-btn"
        href={app.route('sevenstar')}
        onclick={(e) => {
          e.preventDefault();
          m.route.set(app.route('sevenstar'));
        }}
      >
        <i className="fas fa-star" /> 七星查询
      </a>,
      15
    );
  });
});
